import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TimeKeeperEmployersState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: TimeKeeperEmployersState = {
  data: [],
  isLoading: false,
  error: null,
};

const timeKeeperEmployersSlice = createSlice({
  name: 'timeKeeperEmployers',
  initialState,
  reducers: {
    setTimeKeeperEmployers: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setTimeKeeperEmployerLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setTimeKeeperEmployerError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setTimeKeeperEmployers, setTimeKeeperEmployerLoading, setTimeKeeperEmployerError } =
  timeKeeperEmployersSlice.actions;

export default timeKeeperEmployersSlice.reducer;
